<template lang="html">
	<div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label" :class="{error: errors.has('prénom')}">
					<label for="montant">En matière de placement, les conseils d'un professionnel sont :</label>
					<custom-select :items="ratings" :selected="conseilRate" @change="conseilRate=$event"/>
				</div>
				<div class="error-message"></div>
			</div>
			<div class="label solo">
				Combien d'interlocuteurs vous accompagnent sur vos contrats souscrits ?
			</div>
			<div class="ctn-add-children row">
				<div class="btn-add" @click="setContractCounselor(-1)">
					<span class="icon-form-less"></span>
				</div>
				<div class="btn-add" @click="setContractCounselor(1)">
					<span class="icon-form-plus"></span>
				</div>
				<div class="btn-add">
					{{ nbContractCounselor }}
				</div>
			</div>
			<div class="label solo">
				Combien d'interlocuteurs vous accompagnent sur l'ensemble de votre patrimoine ?
			</div>
			<div class="ctn-add-children row">
				<div class="btn-add" @click="setPatrimonialCounselor(-1)">
					<span class="icon-form-less"></span>
				</div>
				<div class="btn-add" @click="setPatrimonialCounselor(1)">
					<span class="icon-form-plus"></span>
				</div>
				<div class="btn-add">
					{{ nbPatrimonialCounselor }}
				</div>
			</div>
		</form>
	</div>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import Rating from '@/common/components/MyPatrimonialLandscape/data/Rating'
import { mapGetters } from 'vuex'

export default {
	name: 'Following',
	components: {
		CustomSelect
	},
	data () {
		return {
			ratings: Rating,
			conseilRate: 'Très important',
			nbContractCounselor: 0,
			nbPatrimonialCounselor: 0
		}
	},
	mounted () {
		this.conseilRate = this.estate.follow.rate || 'Très important'
		this.nbContractCounselor = this.estate.follow.nbContractCounselor || 0
		this.nbPatrimonialCounselor = this.estate.follow.nbPatrimonialCounselor || 0
	},
	methods: {
		setPatrimonialCounselor (value) {
			if (this.nbPatrimonialCounselor >= 0) {
				this.nbPatrimonialCounselor = this.nbPatrimonialCounselor + value
				this.nbPatrimonialCounselor = (this.nbPatrimonialCounselor > 0) ? this.nbPatrimonialCounselor : 0
			}
		},
		setContractCounselor (value) {
			if (this.nbContractCounselor >= 0) {
				this.nbContractCounselor = this.nbContractCounselor + value
				this.nbContractCounselor = (this.nbContractCounselor > 0) ? this.nbContractCounselor : 0
			}
		},
		validate () {
			return new Promise((resolve, reject) => {
				resolve(true)
			})
		},
		save () {
			return new Promise((resolve, reject) => {
				this.$store.dispatch('storePatrimonial', {
					name: 'FOLLOWING',
					data: {
						rate: this.conseilRate,
						nbContractCounselor: this.nbContractCounselor,
						nbPatrimonialCounselor: this.nbPatrimonialCounselor
					},
					fromStart: false
				}).then(() => {
					resolve()
				})
			})
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	}
}
</script>

<style lang="scss" scoped>
.form-ui.landscape-patrimonial-ui {
	.label.solo {
		margin-top: 2rem;
	}
}
</style>



// WEBPACK FOOTER //
// Following.vue?1b676092